import { getOvToken } from 'tokenGeneration/lead.util';
import axios from '../../common/interceptor/app.interceptor';
import config from 'config/config';
import * as query from 'qs';

export const fetchRuntimeConfigAsync = () => {
  return axios({
    method: 'GET',
    url: `${config.ovapiBaseUrl}/config/fetch`,
    headers: {
      'Content-Type': 'application/json'
      // Authorization: `Bearer ${getOvToken()}`
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const fetchOrderDetailsAsync = (params) => {
  return axios({
    method: 'GET',
    url: `${config.ovapiBaseUrl}/orders?${query.stringify(params)}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getOvToken()}`
    },
    skipServiceType: true,
    config: {
      ignoreError: true,
      dedicatedJourney: true
    }
  });
};

export const updateOrderDetailsAsync = (data) => {
  return axios({
    method: 'POST',
    data,
    url: `${config.ovapiBaseUrl}/orders/lineItems/update`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getOvToken()}`
    },
    skipServiceType: true,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};
